module.exports = __webpack_public_path__ + "static/loading-36fba15a3338d9ac042f9af31331515d.gif";